export default __webpack_public_path__ + "assets/images/b321f4b47d4523b8714339a2a92b9a0b.jpeg";